import { Flex } from 'portal-commons';
import { FunctionComponent } from 'react';
import { TableCell, TableRow } from '@material-ui/core';

import { HostingRegion } from '@/apis/core';

interface HostingRegionRowProps {
  checked: boolean;
  option: HostingRegion;
  onChange: (value: string) => void;
}

const HostingRegionRow: FunctionComponent<HostingRegionRowProps> = ({
  checked,
  option,
  onChange,
  ...props
}) => (
  <TableRow {...props}>
    <TableCell>
      <Flex
        sx={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: '7px',
          cursor: 'pointer',
        }}
        onClick={() => onChange(option.id)}
      >
        <input
          style={{ accentColor: '#333E41', cursor: 'pointer' }}
          type="radio"
          name="hostingRegion"
          readOnly
          checked={checked}
        />
        {option.name}
      </Flex>
    </TableCell>
  </TableRow>
);

export default HostingRegionRow;
